import { getV2 } from 'api/request'

// v2 Calendar "calendar" collection — the external calendars (Google, …) connected to the
// workspace. Only used to populate the "Calendar" filter on the events grid; each
// EventOut.calendar points back to one of these. There is no `calendar_list` facet on the
// event list response, so options come from this dedicated endpoint.
//
// GET /v2/core/calendar/calendar/ -> PaginatedResponse[CalendarOut]
//   query params: owner, offset, size
//   CalendarOut: { uid, name, provider_type, provider_ref, is_active, owner, timezone, … }
export const API_CALENDAR = '/core/calendar/calendar'

// `owner` narrows to that user's calendars (used by the create/edit event form, which
// only offers calendars owned by the current user); omit it for the grid's Calendar
// filter, which lists every connected calendar.
export const getCalendarList = ({ owner, offset = 0, size = 200 } = {}) => (
  getV2(`${API_CALENDAR}/`, { urlParams: { owner: owner || undefined, offset, size } })
)
